import styles from './styles.module.scss';

interface InputCheckboxProps extends React.HTMLAttributes<HTMLInputElement> {
    id: any;
    text: string;
    description?: string;
    checked: boolean;
    wrapperClass?: string;
    title?: string;
}

export const InputCheckbox = ({
    id,
    text,
    description,
    checked,
    wrapperClass,
    title,
    ...rest
}: InputCheckboxProps) => {
    return (
        <div className={`${wrapperClass ?? ''} ${styles.wrapper}`} title={title}>
            <input
                id={id}
                type='checkbox'
                className={styles.checkbox}
                checked={checked}
                {...rest}
            />
            <label htmlFor={id} className={styles.label}>
                <div className={styles.text}>{text}</div>
                {description && <div className={styles.description}>{description}</div>}
            </label>
        </div>
    );
};
